import Chart from 'chart.js/auto';
import { ChartOptions } from 'chart.js';

export class ReticleService {
  static onAxisClick = (e: any, chart: Chart, setLastClickedXValue: any) => {
    const chartOptions: any = chart.options;
    const lastClickedXPosition = chartOptions.lastClickedXValue ? undefined : e.x;
    const lastClickedXValue = chart.scales.xAxis.getValueForPixel(lastClickedXPosition);

    // Save Reticle Value
    if (lastClickedXValue) {
      sessionStorage.setItem('lastClickedXValue', lastClickedXValue.toString());
    } else {
      sessionStorage.removeItem('lastClickedXValue');
    }

    setLastClickedXValue(lastClickedXValue);

    chart.update();
  };

  static onAxisHover = (tooltip: any, chart: Chart, setLastHoveredXValue: any) => {
    const lastHoveredXPosition = tooltip.caretX;
    const lastHoveredXValue = chart.scales.xAxis.getValueForPixel(lastHoveredXPosition);

    // Save Reticle Value
    if (lastHoveredXValue) {
      sessionStorage.setItem('lastHoveredXValue', lastHoveredXValue.toString());
    } else {
      sessionStorage.removeItem('lastHoveredXValue');
    }

    setLastHoveredXValue(lastHoveredXValue);
  };

  static getReticleValues = (lastClickedXValue: number, lastHoveredXValue: number) => {
    return {
      lastClickedXValue: lastClickedXValue ? lastClickedXValue : undefined,
      lastHoveredXValue: lastHoveredXValue ? lastHoveredXValue : undefined,
    };
  };

  static drawReticle = (chart: Chart) => {
    const chartOptions: ChartOptions<any> = chart.options;

    if (chartOptions.showReticle && (chartOptions.lastClickedXValue || chartOptions.lastHoveredXValue)) {
      const xValue = chartOptions.lastClickedXValue ? chartOptions.lastClickedXValue : chartOptions.lastHoveredXValue;
      const xValuePixel = chart.scales.xAxis.getPixelForValue(xValue);
      const ctx = chart.ctx;

      ctx.save();
      ctx.strokeStyle = 'rgb(255, 99, 132)';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(xValuePixel, 0);
      ctx.lineTo(xValuePixel, chart.height);
      ctx.stroke();
      ctx.restore();
    }
  };
}
